import { render, staticRenderFns } from "./buy-now.vue?vue&type=template&id=6da268ce"
import script from "./buy-now.vue?vue&type=script&lang=js"
export * from "./buy-now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports